<div class="marginrl30">

  <div class="contentTop">
    <div class="title">Reporting Dashboard</div>
  </div>

  <div class="dashboard-container">
    <div class="item-block">
      <div class="title">Open</div>
      <div>{{reportStatus.openRequests}}</div>
    </div>
    <div class="item-block">
      <div class="title">Overdue</div>
      <div>{{reportStatus.overDueRequests}}</div>
    </div>
    <div class="item-block">
      <div class="title">Overdue in 7 days</div>
      <div>{{reportStatus.overDueInSevenDays}}</div>
    </div>
    <div class="item-block">
      <div class="title">Overdue in 14 days</div>
      <div>{{reportStatus.overDueInFourteenDays}}</div>
    </div>
    <div class="item-block">
      <div class="title">Overdue in 30 days</div>
      <div>{{reportStatus.overDueInThirtyDays}}</div>
    </div>
    <div class="item-block">
      <div class="title">Urgent in past 30 days</div>
      <div>{{reportStatus.urgentInPastThirtyDays}}</div>
    </div>
    <div class="item-block">
      <div class="title">Submitted in past 7 days</div>
      <div>{{reportStatus.submittedInPastSevenDays}}</div>
    </div>
    <div class="item-block">
      <div class="title">Closed/Cancelled in past 7 days</div>
      <div>{{reportStatus.closedOrCancelledInPastSevenDays}}</div>
    </div>
  </div>



<div class="split-container">
  <div class="split left">
    <div class="filter-block">
      <div class="graph-title">Compliant ACDs by Priority</div>

      <app-date-range-picker class="graph-date-range" [setSelectedDate]="rangeSelectionValue_FirstGraph"
        (sendSelectedRange)="rangeSelected($event, 1)"></app-date-range-picker>

      <kendo-dropdownlist class="graph-dropdown" [fillMode]="'flat'" [data]="facilityDD" valueField="id"
        textField="field" [valuePrimitive]="true" [(ngModel)]="priorityFacilityId"
        (valueChange)="getPriorityComplianceStatistics()"></kendo-dropdownlist>
    </div>
    <app-common-chart [setGraphType]="columnGraphType" [setDataSet]="firstChartDataSet"></app-common-chart>

  </div>

  <div class="split right">
    <div class="filter-block">
      <div class="graph-title">Compliance Per Month</div>

      <app-date-range-picker class="graph-date-range" [setSelectedDate]="rangeSelectionValue_SecondGraph"
        (sendSelectedRange)="rangeSelected($event, 2)"></app-date-range-picker>

      <kendo-dropdownlist class="graph-dropdown" [fillMode]="'flat'" [data]="facilityDD" valueField="id"
        textField="field" [valuePrimitive]="true" [(ngModel)]="monthFacilityId"
        (valueChange)="getMonthComplianceStatistics()"></kendo-dropdownlist>
    </div>
    <app-common-chart [setGraphType]="columnGraphType" [setDataSet]="secondChartDataSet"></app-common-chart>
  </div>
</div>

<div class="line-block">
  <div class="filter-block">
    <div class="line-graph-title">ACD Backlog, Submitted, Closed/Cancelled</div>

    <app-date-range-picker class="graph-date-range" [setSelectedDate]="rangeSelectionValue_ThirdGraph"
      (sendSelectedRange)="rangeSelected($event, 3)"></app-date-range-picker>

    <kendo-dropdownlist class="graph-dropdown" [fillMode]="'flat'" [data]="facilityDD" valueField="id" textField="field"
      [valuePrimitive]="true" [(ngModel)]="acdBCSFacilityId"
      (valueChange)="getAcdBscComplianceStatistics()"></kendo-dropdownlist>
  </div>
  <div class="mt-20">
    <app-common-chart class="mt-20" [setLegendVisibiltyStatus]="true" [setGraphType]="lineGraphType"
      [setDataSet]="thirdChartDataSet"></app-common-chart>
  </div>
</div>

<div class="line-block">
  <div class="filter-block">
    <div class="line-graph-title">Average Open Days</div>

    <app-date-range-picker class="graph-date-range" [setSelectedDate]="rangeSelectionValue_FourthGraph"
      (sendSelectedRange)="rangeSelected($event, 4)"></app-date-range-picker>

    <kendo-dropdownlist class="graph-dropdown" [fillMode]="'flat'" [data]="facilityDD" valueField="id" textField="field"
      [valuePrimitive]="true" [(ngModel)]="average7daysFacilityId"
      (valueChange)="getAverageOpenDaysComplianceStatistics()"></kendo-dropdownlist>
  </div>
  <div class="mt-20">
    <app-common-chart [setGraphType]="lineGraphType" [setDataSet]="fourthChartDataSet"></app-common-chart>
  </div>
</div>

</div>